import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { DictionaryItem } from '@hglobal/common';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

import { Country, Currencies, mapRolesFromApi, RolePermissions, Skin, WalletsSkinCollection } from '@pp/core/entities';
import { withOrgId } from '@pp/core/helpers';
import { environment } from '@pp/environment';

import { DictionariesService } from '../dictionaries.service';
import { DictionariesApi } from './dictionaries-api.interface';

const SKINS_API = environment.apiHost + 'skins/';
const API = environment.apiHost;

@Injectable()
export class DictionariesApiService implements DictionariesApi {
  readonly #http = inject(HttpClient);
  protected translate = inject(TranslateService);
  protected dictionariesService = inject(DictionariesService);

  getRoles(): Observable<DictionaryItem<string>[]> {
    const api = environment.apiHost + 'accounts/roles';

    return this.#http
      .get<RolePermissions[]>(api, { headers: withOrgId() })
      .pipe(map(roles => mapRolesFromApi(roles, this.dictionariesService.roles)));
  }

  getCurrencies(): Observable<Currencies> {
    const api = API + 'settings/currencies';

    return this.#http.get<Currencies>(api).pipe(
      map(({ crypto, fiat }) => ({
        crypto: crypto.map(item => ({ ...item, id: item.currencyId })),
        fiat: fiat.map(item => ({ ...item, id: item.currencyId })),
      })),
    );
  }

  getCardsSkins(): Observable<Skin[]> {
    const api = SKINS_API + 'card/';

    return this.#http.get<Skin[]>(api);
  }

  getWalletSkins(): Observable<WalletsSkinCollection> {
    const api = SKINS_API + 'wallet/';

    return this.#http.get<WalletsSkinCollection>(api);
  }

  getCountries(): Observable<Country[]> {
    const api = API + 'settings/countrylist';

    return this.#http
      .get<{ list: Country[] }>(api, { headers: withOrgId() })
      .pipe(map(res => res.list.map((country, index) => ({ ...country, id: index + 1 }))));
  }
}
